import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

export const ObjectWrapper = ({ children, className, ...props }) => {
  return (
    <div
      className={classNames(
        "tw-grid tw-grid-cols-1 lg:tw-grid-cols-[calc(100%-328px)_328px] tw-grid-rows-[auto_auto_1fr] lg:tw-grid-rows-[auto_1fr] tw-min-h-full tw-w-full tw-p-2",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

ObjectWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
